import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 填寫基本資料
 */
const JobAssetInvestmentPostBack = [
    'POST',
    RouteUrlList.API_JobAssetInvestmentPostBack.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: '',
        errorCode: ''
    }
];
export default JobAssetInvestmentPostBack;
